import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Does this work for large 4-bedroom houses?',
  a: "Yes, the protocol scales by adding 'Zone Blocks,' but it's most effective for 1-3 bedroom properties."
}, {
  q: 'Do I need expensive equipment?',
  a: 'No. You probably have 90% of what you need; the protocol just changes how you use it.'
}, {
  q: 'Will guests know I rushed?',
  a: "No. They will see the 'Visual Anchors' are perfect and assume the whole house had a 6-hour deep clean."
}, {
  q: 'How fast will I receive the PDF after I pay?',
  a: 'Instantly. The moment your payment is processed, you are redirected to a download page and the PDF is also sent to your email. You can be reading the protocol in less than 60 seconds — perfect if you are already mid-emergency.'
}, {
  q: "I've never cleaned an Airbnb before. Is this too advanced for me?",
  a: 'Not at all. The protocol was specifically built for solo and "accidental" hosts with zero professional cleaning experience. Every step is written in plain language with the exact sequence to follow — no guesswork, no jargon.'
}, {
  q: 'Can I really clean a full property in under 120 minutes? It sounds too good to be true.',
  a: 'Yes — but only because you stop doing the things that waste time. The Frictionless Turnover System eliminates backtracking, double-cleaning, and "circling." Most users hit the 120-minute mark by their 2nd or 3rd turnover once the pathing becomes muscle memory.'
}, {
  q: "What if it doesn't work for me?",
  a: "If you apply the protocol on your next turnover and it doesn't save you time, just email us within 30 days for a full refund. At $6.36, you are risking less than a coffee to potentially save hundreds in cleaning fees every month."
}, {
  q: 'Is this a physical book or a digital download?',
  a: '100% digital. You get an instant PDF you can open on your phone in the car, print and tape to the inside of your supply closet, or save offline. Nothing ships — no waiting.'
}, {
  q: 'Will this work for co-hosts or short-term rental managers?',
  a: 'Yes. Many hosts use the protocol as a training document for new cleaners or co-hosts, since it standardizes the exact sequence and the 5 Visual Anchors that guarantee 5-star reviews.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-gray-50 py-24" data-id="element-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="text-4xl sm:text-5xl text-brand-dark mb-4" data-id="element-15">
            FREQUENTLY ASKED QUESTIONS
          </h2>
        </div>

        <div className="space-y-4" data-id="element-16">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-17">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-18">
                <span className="text-lg font-semibold text-brand-dark pr-8" data-id="element-19">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-20" />
              </button>

              <AnimatePresence data-id="element-21">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-22">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-23">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}